export default __webpack_public_path__ + "static/media/ic_document_builder.f1b62db2.svg";